import React from 'react';
import PropTypes from 'prop-types';
import Question from '../../common/Question';
import TextAreaInput from '../../common/TextAreaInput';
import YesNoInputGroup from '../../common/YesNoInputGroup';
import './CertificationsTab.scss';

function CertificationsTab({
  project, proposal, onFormChange, errors,
}) {
  const educationExampleText = 'I am not PMP certified but I have held various IT PM roles at Accenture, Pfizer and J&J.';
  const { degrees, accreditations } = project;
  const numberIndexes = [1, 2];

  return (
    <div className="qualifications-tab mb-4">
      { degrees.length === 0 && accreditations.length === 0
        && (
        <div className="body-text-2 mb-4">
          The Employer has not specified any requirements
        </div>
        )}

      { degrees.length > 0
        && (
        <div className="mb-5">
          <Question
            title={`${numberIndexes.shift()}. Do you meet these educational requirements?`}
            className="qualifications-question"
            location="proposal-edit"
          >
            <div className="ms-4 degrees-question">
              <YesNoInputGroup
                options={degrees}
                formKey="degrees"
                value={proposal.degrees}
                onAnswerChange={(val) => onFormChange('degrees', val)}
                errors={errors}
              />
              { proposal.degrees && proposal.degrees.some((el) => el.selected === 'No')
                && (
                <div className="degrees-description">
                  {errors && errors.degrees_desc
                    && (
                    <div className="body-text-2 medium-weight with-error-text mb-2">
                      <i className="fa fa-exclamation-triangle" />
                      {' '}
                      Required!
                    </div>
                    )}
                  <TextAreaInput
                    placeholder="Tell us more."
                    onAnswerChange={(val) => onFormChange('degrees_desc', val)}
                    value={proposal.degrees_desc}
                    error={errors.degrees_desc}
                    textPromptClass={errors && errors.degrees_desc && 'with-error-text'}
                    exampleText={educationExampleText}
                  />
                </div>
                )}
            </div>
          </Question>
        </div>
        )}

      { accreditations.length > 0
        && (
        <div className="mb-5">
          <Question
            className="qualifications-question"
            title={`${numberIndexes.shift()}. Do you meet the following certification requirements?`}
            location="proposal-edit"
          >
            <div className="ms-4">
              <YesNoInputGroup
                options={accreditations}
                formKey="accreditations"
                value={proposal.accreditations}
                onAnswerChange={(val) => onFormChange('accreditations', val)}
                errors={errors}
              />
              { proposal.accreditations && proposal.accreditations.some((el) => el.selected === 'No')
                && (
                <div className="accreditations-description">
                  {errors && errors.accreditations_desc
                    && (
                    <div className="body-text-2 medium-weight with-error-text mb-2">
                      <i className="fa fa-exclamation-triangle" />
                      {' '}
                      Required
                    </div>
                    )}
                  <TextAreaInput
                    placeholder="Tell us more."
                    onAnswerChange={(val) => onFormChange('accreditations_desc', val)}
                    value={proposal.accreditations_desc}
                    error={errors.accreditations_desc}
                    textPromptClass={errors && errors.accreditations_desc && 'with-error-text'}
                  />
                </div>
                )}
            </div>
          </Question>
        </div>
        )}

    </div>
  );
}

CertificationsTab.propTypes = {
  project: PropTypes.shape({}).isRequired,
  proposal: PropTypes.shape({}).isRequired,
  onFormChange: PropTypes.func.isRequired,
  errors: PropTypes.shape({}).isRequired,
};

export default CertificationsTab;
